// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:root {
  --bg-primary: #1e1e1e;
  --bg-secondary: #252526;
  --bg-tertiary: #2d2d30;
  --bg-hover: #2a2d2e;
  --bg-active: #37373d;
  --bg-input: #3c3c3c;
  --border: #3e3e42;
  --text-primary: #cccccc;
  --text-secondary: #969696;
  --text-muted: #6b6b6b;
  --accent: #0e639c;
  --accent-hover: #1177bb;
  --accent-light: #569cd6;
  --green: #4ec9b0;
  --green-dim: #2d4a45;
  --red: #f44747;
  --red-dim: #4a2d2d;
  --yellow: #dcdcaa;
  --orange: #ce9178;
  --purple: #c586c0;
  --activity-bar-width: 48px;
  --side-panel-width: 280px;
  --tab-height: 35px;
  --status-bar-height: 22px;
}

/* ── VSCode Light+ theme ── */
[data-theme="light"] {
  --bg-primary:     #ffffff;
  --bg-secondary:   #f3f3f3;
  --bg-tertiary:    #ebebeb;
  --bg-hover:       #e8e8e8;
  --bg-active:      #dce9f8;
  --bg-input:       #ffffff;
  --border:         #d4d4d4;
  --text-primary:   #1f1f1f;
  --text-secondary: #616161;
  --text-muted:     #9e9e9e;
  --accent:         #005fb8;
  --accent-hover:   #0067c8;
  --accent-light:   #0078d4;
  --green:          #16825d;
  --green-dim:      #d4edda;
  --red:            #c72e0f;
  --red-dim:        #fde8e6;
  --yellow:         #795e26;
  --orange:         #a31515;
  --purple:         #7b3f98;
}

[data-theme="light"] ::-webkit-scrollbar-thumb { background: #c1c1c1; }
[data-theme="light"] ::-webkit-scrollbar-thumb:hover { background: #a0a0a0; }
[data-theme="light"] select option { background: #f3f3f3; }
[data-theme="light"] .badge-essential { background: #deeaf9; color: #005fb8; }

html, body, #root {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 13px;
  background: var(--bg-primary);
  color: var(--text-primary);
}

button {
  cursor: pointer;
  border: none;
  background: none;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
}

input:not([type="checkbox"]), textarea, select {
  font-family: inherit;
  font-size: inherit;
  color: var(--text-primary);
  background: var(--bg-input);
  border: 1px solid var(--border);
  border-radius: 2px;
  padding: 4px 8px;
  outline: none;
}

input:not([type="checkbox"]):focus, textarea:focus, select:focus {
  border-color: var(--accent-light);
}

select option {
  background: var(--bg-secondary);
}

::-webkit-scrollbar { width: 8px; height: 8px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: #424242; border-radius: 4px; }
::-webkit-scrollbar-thumb:hover { background: #555; }

.btn-primary {
  background: var(--accent);
  color: #fff;
  border-radius: 2px;
  padding: 6px 14px;
  font-size: 13px;
  transition: background 0.15s;
}
.btn-primary:hover { background: var(--accent-hover); }
.btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }

.btn-secondary {
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border: 1px solid var(--border);
  border-radius: 2px;
  padding: 6px 14px;
  font-size: 13px;
  transition: background 0.15s;
}
.btn-secondary:hover { background: var(--bg-active); }

.btn-danger {
  background: #6e1414;
  color: #f44747;
  border-radius: 2px;
  padding: 6px 14px;
  font-size: 13px;
  transition: background 0.15s;
}
.btn-danger:hover { background: #8a1a1a; }

.btn-icon {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  border-radius: 3px;
  transition: background 0.1s, color 0.1s;
}
.btn-icon:hover {
  background: var(--bg-hover);
  color: var(--text-primary);
}

/* ── Checkbox ── */
input[type="checkbox"] {
  width: 14px;
  height: 14px;
  accent-color: var(--accent-light);
  cursor: pointer;
  padding: 0;
}

/* ── Module layout ── */
.module-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.module-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
  background: var(--bg-secondary);
}

.module-toolbar-title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--text-secondary);
  margin-right: 8px;
}

.module-search {
  flex: 1;
  max-width: 300px;
}

.module-body {
  flex: 1;
  overflow: auto;
}

/* System / switchboard / room filter dropdowns (utils/listGroups.js) */
.group-filter { max-width: 170px; }
.group-filter.active { border-color: var(--accent-light); color: var(--accent-light); }

/* ── Table ── */
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.data-table th {
  position: sticky;
  top: 0;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 6px 10px;
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
  z-index: 1;
  text-align: left;
}

.data-table td {
  padding: 5px 10px;
  border-bottom: 1px solid var(--border);
  color: var(--text-primary);
  white-space: nowrap;
}

.data-table tr:hover td {
  cursor: pointer;
}

.data-table tr:focus {
  outline: none;
}

.data-table tr.selected td {
  background: var(--bg-active);
}

.cell-check {
  text-align: center;
  padding: 0 4px;
  color: var(--green);
}
.data-table th.cell-check {
  text-align: center;
  padding: 0 4px;
}
.cell-check.no { color: var(--text-muted); }

.cell-num { text-align: right; font-variant-numeric: tabular-nums; }

.badge {
  display: inline-block;
  border-radius: 3px;
  padding: 1px 7px;
  font-size: 11px;
  font-weight: 600;
}
.badge-essential  { background: #2d3b4a; color: #4fc1ff; }
.badge-important  { background: var(--green-dim); color: var(--green); }
.badge-noness     { background: var(--bg-tertiary); color: var(--text-secondary); }
.badge-emergency  { background: var(--red-dim); color: var(--red); }

/* ── Form ── */
.form-wrap {
  padding: 24px 32px;
  overflow-y: auto;
  flex: 1;
}

.form-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 24px;
}

.form-section {
  margin-bottom: 24px;
}

.form-section-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--text-secondary);
  margin-bottom: 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--border);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px 16px;
}

.form-grid-wide {
  grid-template-columns: 1fr 1fr;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.form-field label {
  font-size: 11px;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.form-field input,
.form-field select,
.form-field textarea {
  width: 100%;
}

.form-field textarea {
  resize: vertical;
  min-height: 60px;
}

.form-field-inline {
  display: flex;
  align-items: center;
  gap: 8px;
}

.form-field-inline label {
  font-size: 12px;
  color: var(--text-primary);
  cursor: pointer;
}

.form-readonly {
  padding: 4px 8px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: 2px;
  color: var(--text-secondary);
  font-size: 13px;
}

.form-actions {
  display: flex;
  gap: 8px;
  padding: 16px 32px;
  border-top: 1px solid var(--border);
  flex-shrink: 0;
  background: var(--bg-secondary);
}

.form-actions-right {
  margin-left: auto;
}

.form-error { color: var(--red); font-size: 12px; }
.form-changed {
  font-size: 11px;
  color: var(--text-muted);
  padding: 12px 32px 0;
}

/* ── Sortable table headers ── */
.th-sortable { cursor: pointer; user-select: none; }
.th-sortable:hover { color: var(--text-primary); background: var(--bg-tertiary); }
.th-inner { display: inline-flex; align-items: center; gap: 4px; white-space: nowrap; }
.th-arrow { font-size: 10px; color: var(--text-muted); opacity: 0.35; flex-shrink: 0; }
.th-arrow.th-arrow-active { color: var(--accent-light); opacity: 1; }

/* ── Link button ── */
.btn-link {
  background: none;
  border: none;
  color: var(--accent-light);
  cursor: pointer;
  padding: 2px 6px;
  text-decoration: underline;
}
.btn-link:hover { color: var(--text-primary); }

/* ── Empty state ── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 12px;
  color: var(--text-muted);
  font-size: 14px;
}

/* ── Font size scaling ── */
html { --fz-table: 12px; --fz-th: 11px; --fz-ui: 13px; --fz-small: 11px; }

html[data-fontsize="large"] {
  --fz-table: 14px; --fz-th: 13px; --fz-ui: 15px; --fz-small: 13px;
}
html[data-fontsize="xlarge"] {
  --fz-table: 16px; --fz-th: 15px; --fz-ui: 17px; --fz-small: 15px;
}

html[data-fontsize] .data-table              { font-size: var(--fz-table); }
html[data-fontsize] .data-table th           { font-size: var(--fz-th); }
html[data-fontsize] .data-table td input,
html[data-fontsize] .data-table td select    { font-size: var(--fz-table); }
html[data-fontsize] .ss-trigger,
html[data-fontsize] .ss-drop,
html[data-fontsize] .ss-opt                  { font-size: var(--fz-table); }
html[data-fontsize] .col-filter-popup,
html[data-fontsize] .col-filter-option,
html[data-fontsize] .col-filter-input        { font-size: var(--fz-table); }
html[data-fontsize] .module-toolbar          { font-size: var(--fz-ui); }
html[data-fontsize] .module-search           { font-size: var(--fz-ui); }
html[data-fontsize] .module-toolbar-title    { font-size: var(--fz-ui); }
html[data-fontsize] .side-panel              { font-size: var(--fz-ui); }
html[data-fontsize] .side-panel-title        { font-size: var(--fz-ui); }
html[data-fontsize] .tab-bar                 { font-size: var(--fz-ui); }
html[data-fontsize] .btn-primary,
html[data-fontsize] .btn-secondary           { font-size: var(--fz-ui); }
html[data-fontsize] .badge                   { font-size: var(--fz-small); }
html[data-fontsize] .th-arrow               { font-size: var(--fz-small); }
html[data-fontsize] .cell-note,
html[data-fontsize] .cell-num               { font-size: var(--fz-table); }

/* ── Mobile ── */
@media (max-width: 768px), (hover: none) and (max-width: 1024px) {
  input, textarea, select { font-size: 16px !important; }
  .form-wrap { padding: 16px; }
  .form-grid { grid-template-columns: 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,iDAAiD,mBAAmB,EAAE;AACtE,uDAAuD,mBAAmB,EAAE;AAC5E,qCAAqC,mBAAmB,EAAE;AAC1D,wCAAwC,mBAAmB,EAAE,cAAc,EAAE;;AAE7E;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,8EAA8E;EAC9E,eAAe;EACf,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,sBAAsB,UAAU,EAAE,WAAW,EAAE;AAC/C,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,mBAAmB,EAAE,kBAAkB,EAAE;AACrE,kCAAkC,gBAAgB,EAAE;;AAEpD;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;AACA,qBAAqB,+BAA+B,EAAE;AACtD,wBAAwB,YAAY,EAAE,mBAAmB,EAAE;;AAE3D;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;AACA,uBAAuB,4BAA4B,EAAE;;AAErD;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;AACA,oBAAoB,mBAAmB,EAAE;;AAEzC;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sCAAsC;EACtC,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA,uEAAuE;AACvE,gBAAgB,gBAAgB,EAAE;AAClC,uBAAuB,iCAAiC,EAAE,0BAA0B,EAAE;;AAEtF,gBAAgB;AAChB;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA,iBAAiB,wBAAwB,EAAE;;AAE3C,YAAY,iBAAiB,EAAE,kCAAkC,EAAE;;AAEnE;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,oBAAoB,4BAA4B,EAAE,mBAAmB,EAAE;AACvE,oBAAoB,8BAA8B,EAAE,4BAA4B,EAAE;AAClF,oBAAoB,0BAA0B,EAAE,iBAAiB,EAAE;;AAEnE,eAAe;AACf;EACE,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,cAAc,iBAAiB,EAAE,eAAe,EAAE;AAClD;EACE,eAAe;EACf,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA,iCAAiC;AACjC,eAAe,eAAe,EAAE,iBAAiB,EAAE;AACnD,qBAAqB,0BAA0B,EAAE,8BAA8B,EAAE;AACjF,YAAY,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACtF,YAAY,eAAe,EAAE,wBAAwB,EAAE,aAAa,EAAE,cAAc,EAAE;AACtF,4BAA4B,0BAA0B,EAAE,UAAU,EAAE;;AAEpE,sBAAsB;AACtB;EACE,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA,kBAAkB,0BAA0B,EAAE;;AAE9C,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,eAAe;AACjB;;AAEA,4BAA4B;AAC5B,OAAO,gBAAgB,EAAE,aAAa,EAAE,aAAa,EAAE,gBAAgB,EAAE;;AAEzE;EACE,gBAAgB,EAAE,aAAa,EAAE,aAAa,EAAE,gBAAgB;AAClE;AACA;EACE,gBAAgB,EAAE,aAAa,EAAE,aAAa,EAAE,gBAAgB;AAClE;;AAEA,+CAA+C,0BAA0B,EAAE;AAC3E,+CAA+C,uBAAuB,EAAE;AACxE;+CAC+C,0BAA0B,EAAE;AAC3E;;+CAE+C,0BAA0B,EAAE;AAC3E;;+CAE+C,0BAA0B,EAAE;AAC3E,+CAA+C,uBAAuB,EAAE;AACxE,+CAA+C,uBAAuB,EAAE;AACxE,+CAA+C,uBAAuB,EAAE;AACxE,+CAA+C,uBAAuB,EAAE;AACxE,+CAA+C,uBAAuB,EAAE;AACxE,+CAA+C,uBAAuB,EAAE;AACxE;+CAC+C,uBAAuB,EAAE;AACxE,+CAA+C,0BAA0B,EAAE;AAC3E,8CAA8C,0BAA0B,EAAE;AAC1E;8CAC8C,0BAA0B,EAAE;;AAE1E,iBAAiB;AACjB;EACE,0BAA0B,0BAA0B,EAAE;EACtD,aAAa,aAAa,EAAE;EAC5B,aAAa,0BAA0B,EAAE;AAC3C","sourcesContent":["*, *::before, *::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  --bg-primary: #1e1e1e;\n  --bg-secondary: #252526;\n  --bg-tertiary: #2d2d30;\n  --bg-hover: #2a2d2e;\n  --bg-active: #37373d;\n  --bg-input: #3c3c3c;\n  --border: #3e3e42;\n  --text-primary: #cccccc;\n  --text-secondary: #969696;\n  --text-muted: #6b6b6b;\n  --accent: #0e639c;\n  --accent-hover: #1177bb;\n  --accent-light: #569cd6;\n  --green: #4ec9b0;\n  --green-dim: #2d4a45;\n  --red: #f44747;\n  --red-dim: #4a2d2d;\n  --yellow: #dcdcaa;\n  --orange: #ce9178;\n  --purple: #c586c0;\n  --activity-bar-width: 48px;\n  --side-panel-width: 280px;\n  --tab-height: 35px;\n  --status-bar-height: 22px;\n}\n\n/* ── VSCode Light+ theme ── */\n[data-theme=\"light\"] {\n  --bg-primary:     #ffffff;\n  --bg-secondary:   #f3f3f3;\n  --bg-tertiary:    #ebebeb;\n  --bg-hover:       #e8e8e8;\n  --bg-active:      #dce9f8;\n  --bg-input:       #ffffff;\n  --border:         #d4d4d4;\n  --text-primary:   #1f1f1f;\n  --text-secondary: #616161;\n  --text-muted:     #9e9e9e;\n  --accent:         #005fb8;\n  --accent-hover:   #0067c8;\n  --accent-light:   #0078d4;\n  --green:          #16825d;\n  --green-dim:      #d4edda;\n  --red:            #c72e0f;\n  --red-dim:        #fde8e6;\n  --yellow:         #795e26;\n  --orange:         #a31515;\n  --purple:         #7b3f98;\n}\n\n[data-theme=\"light\"] ::-webkit-scrollbar-thumb { background: #c1c1c1; }\n[data-theme=\"light\"] ::-webkit-scrollbar-thumb:hover { background: #a0a0a0; }\n[data-theme=\"light\"] select option { background: #f3f3f3; }\n[data-theme=\"light\"] .badge-essential { background: #deeaf9; color: #005fb8; }\n\nhtml, body, #root {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 13px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\nbutton {\n  cursor: pointer;\n  border: none;\n  background: none;\n  font-family: inherit;\n  font-size: inherit;\n  color: inherit;\n}\n\ninput:not([type=\"checkbox\"]), textarea, select {\n  font-family: inherit;\n  font-size: inherit;\n  color: var(--text-primary);\n  background: var(--bg-input);\n  border: 1px solid var(--border);\n  border-radius: 2px;\n  padding: 4px 8px;\n  outline: none;\n}\n\ninput:not([type=\"checkbox\"]):focus, textarea:focus, select:focus {\n  border-color: var(--accent-light);\n}\n\nselect option {\n  background: var(--bg-secondary);\n}\n\n::-webkit-scrollbar { width: 8px; height: 8px; }\n::-webkit-scrollbar-track { background: transparent; }\n::-webkit-scrollbar-thumb { background: #424242; border-radius: 4px; }\n::-webkit-scrollbar-thumb:hover { background: #555; }\n\n.btn-primary {\n  background: var(--accent);\n  color: #fff;\n  border-radius: 2px;\n  padding: 6px 14px;\n  font-size: 13px;\n  transition: background 0.15s;\n}\n.btn-primary:hover { background: var(--accent-hover); }\n.btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }\n\n.btn-secondary {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border: 1px solid var(--border);\n  border-radius: 2px;\n  padding: 6px 14px;\n  font-size: 13px;\n  transition: background 0.15s;\n}\n.btn-secondary:hover { background: var(--bg-active); }\n\n.btn-danger {\n  background: #6e1414;\n  color: #f44747;\n  border-radius: 2px;\n  padding: 6px 14px;\n  font-size: 13px;\n  transition: background 0.15s;\n}\n.btn-danger:hover { background: #8a1a1a; }\n\n.btn-icon {\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-secondary);\n  border-radius: 3px;\n  transition: background 0.1s, color 0.1s;\n}\n.btn-icon:hover {\n  background: var(--bg-hover);\n  color: var(--text-primary);\n}\n\n/* ── Checkbox ── */\ninput[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n  accent-color: var(--accent-light);\n  cursor: pointer;\n  padding: 0;\n}\n\n/* ── Module layout ── */\n.module-wrap {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n.module-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n  background: var(--bg-secondary);\n}\n\n.module-toolbar-title {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: var(--text-secondary);\n  margin-right: 8px;\n}\n\n.module-search {\n  flex: 1;\n  max-width: 300px;\n}\n\n.module-body {\n  flex: 1;\n  overflow: auto;\n}\n\n/* System / switchboard / room filter dropdowns (utils/listGroups.js) */\n.group-filter { max-width: 170px; }\n.group-filter.active { border-color: var(--accent-light); color: var(--accent-light); }\n\n/* ── Table ── */\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.data-table th {\n  position: sticky;\n  top: 0;\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  font-weight: 600;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  padding: 6px 10px;\n  border-bottom: 1px solid var(--border);\n  white-space: nowrap;\n  z-index: 1;\n  text-align: left;\n}\n\n.data-table td {\n  padding: 5px 10px;\n  border-bottom: 1px solid var(--border);\n  color: var(--text-primary);\n  white-space: nowrap;\n}\n\n.data-table tr:hover td {\n  cursor: pointer;\n}\n\n.data-table tr:focus {\n  outline: none;\n}\n\n.data-table tr.selected td {\n  background: var(--bg-active);\n}\n\n.cell-check {\n  text-align: center;\n  padding: 0 4px;\n  color: var(--green);\n}\n.data-table th.cell-check {\n  text-align: center;\n  padding: 0 4px;\n}\n.cell-check.no { color: var(--text-muted); }\n\n.cell-num { text-align: right; font-variant-numeric: tabular-nums; }\n\n.badge {\n  display: inline-block;\n  border-radius: 3px;\n  padding: 1px 7px;\n  font-size: 11px;\n  font-weight: 600;\n}\n.badge-essential  { background: #2d3b4a; color: #4fc1ff; }\n.badge-important  { background: var(--green-dim); color: var(--green); }\n.badge-noness     { background: var(--bg-tertiary); color: var(--text-secondary); }\n.badge-emergency  { background: var(--red-dim); color: var(--red); }\n\n/* ── Form ── */\n.form-wrap {\n  padding: 24px 32px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.form-title {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 24px;\n}\n\n.form-section {\n  margin-bottom: 24px;\n}\n\n.form-section-title {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: var(--text-secondary);\n  margin-bottom: 12px;\n  padding-bottom: 6px;\n  border-bottom: 1px solid var(--border);\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 12px 16px;\n}\n\n.form-grid-wide {\n  grid-template-columns: 1fr 1fr;\n}\n\n.form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.form-field label {\n  font-size: 11px;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.form-field input,\n.form-field select,\n.form-field textarea {\n  width: 100%;\n}\n\n.form-field textarea {\n  resize: vertical;\n  min-height: 60px;\n}\n\n.form-field-inline {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.form-field-inline label {\n  font-size: 12px;\n  color: var(--text-primary);\n  cursor: pointer;\n}\n\n.form-readonly {\n  padding: 4px 8px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: 2px;\n  color: var(--text-secondary);\n  font-size: 13px;\n}\n\n.form-actions {\n  display: flex;\n  gap: 8px;\n  padding: 16px 32px;\n  border-top: 1px solid var(--border);\n  flex-shrink: 0;\n  background: var(--bg-secondary);\n}\n\n.form-actions-right {\n  margin-left: auto;\n}\n\n.form-error { color: var(--red); font-size: 12px; }\n.form-changed {\n  font-size: 11px;\n  color: var(--text-muted);\n  padding: 12px 32px 0;\n}\n\n/* ── Sortable table headers ── */\n.th-sortable { cursor: pointer; user-select: none; }\n.th-sortable:hover { color: var(--text-primary); background: var(--bg-tertiary); }\n.th-inner { display: inline-flex; align-items: center; gap: 4px; white-space: nowrap; }\n.th-arrow { font-size: 10px; color: var(--text-muted); opacity: 0.35; flex-shrink: 0; }\n.th-arrow.th-arrow-active { color: var(--accent-light); opacity: 1; }\n\n/* ── Link button ── */\n.btn-link {\n  background: none;\n  border: none;\n  color: var(--accent-light);\n  cursor: pointer;\n  padding: 2px 6px;\n  text-decoration: underline;\n}\n.btn-link:hover { color: var(--text-primary); }\n\n/* ── Empty state ── */\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  gap: 12px;\n  color: var(--text-muted);\n  font-size: 14px;\n}\n\n/* ── Font size scaling ── */\nhtml { --fz-table: 12px; --fz-th: 11px; --fz-ui: 13px; --fz-small: 11px; }\n\nhtml[data-fontsize=\"large\"] {\n  --fz-table: 14px; --fz-th: 13px; --fz-ui: 15px; --fz-small: 13px;\n}\nhtml[data-fontsize=\"xlarge\"] {\n  --fz-table: 16px; --fz-th: 15px; --fz-ui: 17px; --fz-small: 15px;\n}\n\nhtml[data-fontsize] .data-table              { font-size: var(--fz-table); }\nhtml[data-fontsize] .data-table th           { font-size: var(--fz-th); }\nhtml[data-fontsize] .data-table td input,\nhtml[data-fontsize] .data-table td select    { font-size: var(--fz-table); }\nhtml[data-fontsize] .ss-trigger,\nhtml[data-fontsize] .ss-drop,\nhtml[data-fontsize] .ss-opt                  { font-size: var(--fz-table); }\nhtml[data-fontsize] .col-filter-popup,\nhtml[data-fontsize] .col-filter-option,\nhtml[data-fontsize] .col-filter-input        { font-size: var(--fz-table); }\nhtml[data-fontsize] .module-toolbar          { font-size: var(--fz-ui); }\nhtml[data-fontsize] .module-search           { font-size: var(--fz-ui); }\nhtml[data-fontsize] .module-toolbar-title    { font-size: var(--fz-ui); }\nhtml[data-fontsize] .side-panel              { font-size: var(--fz-ui); }\nhtml[data-fontsize] .side-panel-title        { font-size: var(--fz-ui); }\nhtml[data-fontsize] .tab-bar                 { font-size: var(--fz-ui); }\nhtml[data-fontsize] .btn-primary,\nhtml[data-fontsize] .btn-secondary           { font-size: var(--fz-ui); }\nhtml[data-fontsize] .badge                   { font-size: var(--fz-small); }\nhtml[data-fontsize] .th-arrow               { font-size: var(--fz-small); }\nhtml[data-fontsize] .cell-note,\nhtml[data-fontsize] .cell-num               { font-size: var(--fz-table); }\n\n/* ── Mobile ── */\n@media (max-width: 768px), (hover: none) and (max-width: 1024px) {\n  input, textarea, select { font-size: 16px !important; }\n  .form-wrap { padding: 16px; }\n  .form-grid { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
